export function maxBy<T>(array: T[], fn: (item: T) => number): T | undefined {
  if (array.length === 0) {
    return undefined;
  }
  
  return array.reduce((maxItem, currentItem) => {
    return fn(currentItem) > fn(maxItem) ? currentItem : maxItem;
  });
}

export function logDebug(msg: string) {
  if (process.env.NODE_ENV === 'development') {
    console.debug(`Version.Compare: ${msg}`);
  }
}

export function logError(msg: string) {
  console.error(`Version.Compare: ${msg}`);
}

export function generateUUID() {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const buf = new Uint8Array(16);
    crypto.getRandomValues(buf);

    // Per RFC 4122, set version (4) and variant bits
    buf[6] = (buf[6] & 0x0f) | 0x40; // Version 4
    buf[8] = (buf[8] & 0x3f) | 0x80; // Variant bits

    // Convert bytes to hex strings
    const byteToHex = [];
    for (let i = 0; i < 256; ++i) {
      byteToHex.push((i + 0x100).toString(16).substr(1));
    }

    return (
      byteToHex[buf[0]] +
      byteToHex[buf[1]] +
      byteToHex[buf[2]] +
      byteToHex[buf[3]] + '-' +
      byteToHex[buf[4]] +
      byteToHex[buf[5]] + '-' +
      byteToHex[buf[6]] +
      byteToHex[buf[7]] + '-' +
      byteToHex[buf[8]] +
      byteToHex[buf[9]] + '-' +
      byteToHex[buf[10]] +
      byteToHex[buf[11]] +
      byteToHex[buf[12]] +
      byteToHex[buf[13]] +
      byteToHex[buf[14]] +
      byteToHex[buf[15]]
    );
  } else {
    // Fallback to Math.random (not cryptographically secure)
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); 
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
}

export function observerOptions() {
  return {
    root: null,
    rootMargin: "0px",
    threshold: 0.8,
  };
}